
import { Component, Prop, Vue } from "vue-property-decorator";
import { AsyncComponentFactory } from "vue/types/options";
import Loading from "./components/Loading.vue";


@Component<any>({})
export default class App extends Vue {
  started = false;
 
}
